import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment, endpoints } from '@environment';
import {
  Goal,
  CreateGoalRequest,
  UpdateGoalRequest,
  PagedRequest,
  PagedResponse,
} from '@core/models';

@Injectable({ providedIn: 'root' })
export class GoalService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/${endpoints.v1.goals}`;

  getAll(): Observable<Goal[]> {
    return this.http.get<Goal[]>(this.baseUrl);
  }

  getById(id: string): Observable<Goal> {
    return this.http.get<Goal>(`${this.baseUrl}/${id}`);
  }

  getPaged(request: PagedRequest): Observable<PagedResponse<Goal>> {
    return this.http.post<PagedResponse<Goal>>(
      `${this.baseUrl}/paged`,
      request
    );
  }

  create(goal: CreateGoalRequest): Observable<Goal> {
    return this.http.post<Goal>(this.baseUrl, goal);
  }

  update(id: string, goal: UpdateGoalRequest): Observable<Goal> {
    return this.http.put<Goal>(`${this.baseUrl}/${id}`, goal);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }
}
